export const ProductState = {
  NORMAL: "Normal",
  DAMAGED: "Damaged",
  LOST_CODE: "LostCode",
};

export const ProductStateList = [
  {
    id: ProductState.NORMAL,
    title: "Bình thường",
  },
  {
    id: ProductState.DAMAGED,
    title: "Hư hỏng",
  },
  {
    id: ProductState.LOST_CODE,
    title: "Mất số serial",
  },
];

export const ProductStateTranslation = {
  LostCode: "Mất số serial",
  Normal: "Bình thường",
  Damaged: "Hư hỏng",
};

export const selectList = [{ id: 1, title: "Kho nhập trả hàng", value: "warehouse" }];
export const customList = [{ id: 1, title: "Khách hàng", value: "customer" }];
export const saleList = [{ id: 1, title: "NV kinh doanh", value: "sale" }];
export const productList = [{ id: 1, title: "Sản phẩm", value: "product" }];
export const productModelList = [{ id: 1, title: "Phân loại SP", value: "productModel" }];
export const customerList = [{ id: 1, title: "Khách hàng", value: "customer" }];
